import axios from "axios";
import { Message } from "element-ui";
import Rsa from "@/js/Rsa.js";
import { timeFun } from "@/js/public.js";
import { getToken } from "./login.js";

export const urlList = [
  "https://api.hakspay.cn",
  "https://api2.hakspay.cn",
  "https://api3.hakspay.cn",
  "https://pay.swiftpass.cn/pay/gateway",
  "https://test-api.hakspay.cn"
];

/**
 * 表示微信接口通用地址
 * @type {String}
 * @description 表示微信接口通用地址
 */
export const wxbaseurl = "https://mp.weixin.qq.com";
/**
 * 导出请求地址根目录
 */
export const baseUrl = urlList[4];
localStorage.setItem("baseUrl", urlList[4]);
axios.defaults.baseURL = localStorage.getItem("baseUrl");
axios.defaults.headers.post["Content-Type"] = "application/json";

/* 公众号id */
export const officialId =
  process.env.NODE_ENV == "development"
    ? "wx59275b1f7f83e45f"
    : "wxf003ddc051b4643b";

/* wx59275b1f7f83e45f test -- 微信公众号测试id */

//排除不用加请求头的请求路径
const excludeUrlList = ["common/v2/getsyskey", "wxhelper/v2/card/list", "ServiceProvider/v2/login", "Merchant/v2/common/login", "Membership/v2/Account/login"];

//请求拦截器
axios.interceptors.request.use(async function (res) {

  try {
    //判断有令牌并且不是获取 公钥的接口 在请求头上加 Authorization
    if (
      localStorage.getItem("access_token") &&
      excludeUrlList.indexOf(res.url) < 0
    ) {//判断本地有令牌并且 没有在排除数组中
      res.headers.Authorization = `Token token_type=${localStorage.getItem(
        "token_type"
      )}&access_token=${await $encrypt(localStorage.getItem("access_token"))}`;
    }
    const expire_time = new Date(localStorage.getItem("expire_time"));
    const now_time = new Date();
    //没有超时
    if (
      localStorage.getItem("expire_time") &&
      localStorage.getItem("access_token") &&
      expire_time > now_time
    ) {
      return res; //继续执行
    } else {
      if (excludeUrlList.indexOf(res.url) < 0) {
        await getToken();
        return res;
      } else {
        return res;
      }
    }
    //接口需要令牌的情况
  } catch (e) {
    console.log("出错", e);
    return res;
  } /*finally {
    return res;
  } */
});

/* import Vue from "vue";
import devVue from "../main-dev.js";
console.log(Vue)
console.log(devVue) */
/* if(process.env.NODE_ENV==="development"){
  _that = devVue
}else if(process.env.NODE_ENV==="production"){
  _that = prodVue
} */



/**
 * timer 一个定时器，设置为一分钟
 * key rsa key
 * count 第几次调用
 */
let timer = null;
let cachedKey = "";
let requestCount = 0;//请求的次数
let isFetching = false; // 防止并发请求
let pendingPromise = null; // 缓存正在进行的请求
/**
 * 获取 RSA 系统公钥
 * https://test-api.hakspay.cn/v2/ePlatform/Service/common/getsyskey
 * @returns 
 */
export const getRsaKey = async function () {
  clearTimeout(timer);

  // 1. 如果有缓存且在 1 分钟内，直接返回
  if (requestCount > 0 && cachedKey) {
    console.log(`第${requestCount}次请求`, cachedKey);
    return Promise.resolve(cachedKey);
  }
  requestCount++;
  // 2. 如果正在请求中，返回同一个 Promise
  if (isFetching) {
    return pendingPromise;
  }
  // 3. 第一次请求或缓存过期
  isFetching = true;
  pendingPromise = new Promise((resolve, reject) => {
    axios
      .get("common/v2/getsyskey")
      .then((res) => {
        if (res.data?.public_key) {
          cachedKey = res.data.public_key;
          resolve(cachedKey);
        } else {
          reject(new Error("未获取到key"));
        }
      })
      .catch((error) => {
        reject(error);
        Message.error(error.message);
      })
      .finally(() => {
        isFetching = false;
      });
  });
  timer = setTimeout(() => {
    requestCount = 0;
  }, 60000);
  return pendingPromise;
};

/**
 * 节流函数
 * @returns rsakey
 *//* 
export const antiShake = async function() {
clearTimeout(timer);
if (count == 0) {
console.log("count==0数量等于0");
key = await getRsaKey();
}
count++;
timer = setTimeout(() => {
count = 0;
console.log("重新开始");
}, 60000);
console.log(`第--${count}--次调用！`);
return key;
}; */

/**
 * 上传图片接口
 * common/v2/UploadImg
 * @param {string} img base64
 * @param {string} file_type JPG,GIF,JPEG
 * @returns
 * 获取图片  `${baseUrl}/media/image/${res.data.resp_data.media_no}.${file_type}`
 */
export const commonUploadImg = function (img, file_type) {
  return axios.post("common/v2/UploadImg", {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    merchant_id: localStorage.getItem("merchant_id")
      ? localStorage.getItem("merchant_id")
      : "",
    service_no: localStorage.getItem("service_no")
      ? localStorage.getItem("service_no")
      : "",
    img,
    file_type
  });
};

/**
 * 识别营业执照
 * Common/v2/TxtDiscern/DiscernLicense
 * @param {*} img base64格式的图片对象
 * @returns
 */
export const submitDiscernLicense = function (img) {
  return axios.post("Common/v2/TxtDiscern/DiscernLicense", {
    access_token: localStorage.getItem("access_token"),
    token_type: localStorage.getItem("token_type"),
    base64: img
  });
};

/**
 * rsa加密
 * @param {string} str 需要加密的值
 * @param {string} key  需要加密值的字段名
 * @returns 加密后的值
 */
export const $encrypt = async function (str, key) {
  const rsakey = await getRsaKey();
  console.log("rsakey-------------------------", rsakey);
  return Rsa.encrypt(
    JSON.stringify({
      time_stamp: timeFun("eng"),
      plaintext: str
    }),
    rsakey
  );
};

export const testR = function (res) {
  // Message.error(JSON.stringify(res));
  if (res.data.return_code == "FAIL" || res.data.return_msg) {
    Message.error(res.data.return_msg);
    return false;
  } else if (res.data.result_code == "FAIL" || res.data.result_msg) {
    Message.error(res.data.result_msg);
    return false;
  } else if (res.data.error_code == "FAIL" || res.data.error_msg) {
    Message.error(res.data.error_msg);
    return false;
  } else if (
    res.data.return_code == "SUCCESS" &&
    res.data.result_code == "SUCCESS" &&
    res.data.resp_data &&
    res.data.resp_data.isSuccess == false
  ) {
    Message.error(res.data.resp_data.msg);
    return false;
  } else if (
    res.data.return_code == "SUCCESS" &&
    res.data.result_code == "SUCCESS" &&
    res.data.resp_data
  ) {
    return true;
  }
};

export default axios;
